import { render, staticRenderFns } from "./Questionaire.vue?vue&type=template&id=0ed8d0ec&scoped=true&"
import script from "./Questionaire.vue?vue&type=script&lang=js&"
export * from "./Questionaire.vue?vue&type=script&lang=js&"
import style0 from "./Questionaire.vue?vue&type=style&index=0&id=0ed8d0ec&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8d0ec",
  null
  
)

export default component.exports